import { Api } from "@/utils/http/types";
import { RequestEnum } from "@/enums/httpEnum";

const testApis = {
  checkPassword: new Api({
    url: "/api/user/checkPassword",
    desc: "检测管理密码是否正确",
    method: RequestEnum.GET
  })
};

export default testApis;

export interface SysConfig {
  id: string;
}
